/**
 * Format an elapsed duration (in whole seconds) for inline status timers.
 *
 * Shared by the typing indicator and the sub-agent activity card so elapsed
 * time reads consistently everywhere: `45s`, `3m 52s`, `1h 4m`.
 */
export function formatElapsed(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  const mins = Math.floor(seconds / 60);
  if (mins < 60) {
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  }
  const hours = Math.floor(mins / 60);
  return `${hours}h ${mins % 60}m`;
}
